import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeKnowledgeTimelineResponseDataSchema,
  DataResponse,
  GetBackofficeKnowledgeMetricsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeKnowledgeMetricsSchema>
type Response = DataResponse<z.infer<typeof BackofficeKnowledgeTimelineResponseDataSchema>>

export const getBackofficeKnowledgeTimelineQuery = ({ query }: { query: Query }) => {
  return queryOptions({
    placeholderData: () => undefined,
    queryKey: ["backofficeKnowledgeTimeline", query],
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<Response>("/backoffice/knowledge/timeline", {
        params: query,
        signal,
      })
      return data.data
    },
  })
}
